import { render } from "./ActiveDeals.vue?vue&type=template&id=1cb82a06"
import script from "./ActiveDeals.vue?vue&type=script&lang=js"
export * from "./ActiveDeals.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__